export default {
	URL: 'https://api-applambari.infinitum-ti.com',
	API_URL: 'https://api-applambari.infinitum-ti.com/api',
	OAPI_URL: 'https://api-applambari.infinitum-ti.com/oapi',
	// URL: 'http://localhost:3008',
	// API_URL: 'http://localhost:3008/api',
	// OAPI_URL: 'http://localhost:3008/oapi',
}
